import { ROUTES } from '@/constants/paths';

export const createCampaignRedirectorPath = (campaignUid: string) =>
  ROUTES.WILD_CARD_CAMPAIGN.replace(':id', campaignUid);
